module.exports = __webpack_public_path__ + "static/media/color-chart.85c479ee.jpg";